module.exports = __webpack_public_path__ + "img/instagram.e87eb8e0.svg";